import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinuxComponent } from './simple-icons-linux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinuxComponent ],
    exports:      [ SimpleIconsLinuxComponent ],
    bootstrap:    []
})
export class SimpleIconsLinuxModule {}
